import { SwiperSlide } from "swiper/react"
import { Card } from "@components/anti/Card"
import { SliderSwiper } from "@components/anti/Slider/Swiper"
import SwiperNavigation from "@components/global/SwiperNavigation"
import { useCustomNavSwiper, useScrollAnim } from "src/hooks/hooks"
import { convertJson, imgUrl } from "src/mixins"

function ProductsServicesCinemaFacilities({ data, locale, isCinema }) {
  const [swiperRef, handlePrev, handleNext] = useCustomNavSwiper()
  const [trigger, anim] = useScrollAnim()
  const loop = !isCinema && data?.length > 2
  const breakpoints = isCinema
    ? {
        365: {
          slidesPerView: 1.3,
          spaceBetween: 15,
        },
        640: {
          slidesPerView: 1.6,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3.2,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 4.1,
          spaceBetween: 15,
        },
      }
    : {
        365: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        640: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
      }
  return (
    <section className="sc-products-services-facilities" ref={trigger}>
      <div className="py-main">
        <div className="container">
          <div className="row-title">
            <h1 className={`title ${anim(1)}`}>
              {data && data[`title_${locale}`]}
            </h1>
            {(isCinema && convertJson(data.items)?.length > 4) ||
            (!isCinema && convertJson(data.items)?.length > 2) ? (
              <SwiperNavigation
                handleNext={handleNext}
                handlePrev={handlePrev}
                theme="dark"
              />
            ) : null}
          </div>
          <SliderSwiper
            swiperRef={swiperRef}
            loop={loop}
            breakpoints={breakpoints}
            className="concession-slider mt-4"
          >
            {convertJson(data.items)?.map((item, i) => (
              <SwiperSlide key={`concession-${i}`}>
                <Card
                  img={imgUrl(item?.image)}
                  variant="overlay"
                  // imgOverlay="50"
                  imgRatio={isCinema ? "r-3-4" : "r-4-3"}
                  title={item[`title_${locale}`]}
                  titleClassName="text-truncate-threeline"
                  className={anim(i + 2)}
                />
              </SwiperSlide>
            ))}
          </SliderSwiper>
        </div>
      </div>
    </section>
  )
}

export default ProductsServicesCinemaFacilities
